import React, { FC, memo } from 'react';
import LockIcon from '@mui/icons-material/Lock';
import { Typography } from '@mui/material';
import { RestrictedTabProps } from '../../types';

const RestrictedTab: FC<RestrictedTabProps> = ({ children }) => {
  return (
    <Typography display='flex' gap='8px'>
      {children}

      <LockIcon />
    </Typography>
  );
};

export default memo(RestrictedTab);
